module.exports = __webpack_public_path__ + "img/Group-58.13613a07.jpg";